var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPasswordResetImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "311px",
    height: "330px",
    viewBox: "0 0 311 330",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B66E4CC8-DC58-45B7-AF1A-14C6B2741A4D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 4.9465635 0 4.9465635 7.09340447 0 7.09340447"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 0 4.9465635 0 4.9465635 7.09340447 0 7.09340447"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "0 0 4.9465635 0 4.9465635 7.09340447 0 7.09340447"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-7",
    points: "0 0 4.9465635 0 4.9465635 7.09340447 0 7.09340447"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-9",
    points: "0 0 4.9465635 0 4.9465635 7.09340447 0 7.09340447"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-11",
    points: "0 0 4.9465635 0 4.9465635 7.09340447 0 7.09340447"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-13",
    x: 0,
    y: 0,
    width: 2.58081574,
    height: 7.09340447
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-15",
    x: 0,
    y: 0,
    width: 2.58081574,
    height: 7.09340447
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-17",
    points: "0 0 4.9465635 0 4.9465635 7.09340447 0 7.09340447"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-19",
    points: "0 0 4.9465635 0 4.9465635 7.09340447 0 7.09340447"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-21",
    points: "0 0 4.9465635 0 4.9465635 7.09340447 0 7.09340447"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-23",
    points: "0 0 4.9465635 0 4.9465635 7.09340447 0 7.09340447"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-25",
    points: "0 0 4.9465635 0 4.9465635 7.09340447 0 7.09340447"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1-SignIn/SignUp",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.1.2-Mojo-SignIn-resetPass",
    transform: "translate(-223.000000, -253.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "left-side"
  }, /*#__PURE__*/React.createElement("g", {
    id: "welcome-signIn-reset-img",
    transform: "translate(224.000000, 253.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(14.000000, 188.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.111423,44.971706 C223.080033,44.3778312 223.374199,43.9817588 223.695271,43.7961145 C224.067014,43.5833483 224.516335,43.5978445 224.894805,43.8171573 C225.141887,43.4636381 225.455335,43.2143977 225.816316,43.0900114 C226.226176,42.9473879 226.671909,42.9749773 227.071455,43.1676359 C227.710908,43.4753286 228.188031,44.2080859 227.990276,45.0764525 C228.843179,45.4692516 229.065597,46.2090232 228.984432,46.7631505 C228.879052,47.4743974 228.318971,47.9906476 227.652164,47.9906476 C227.606425,47.9915829 225.101977,48 223.582716,48 C222.567036,48 222.052245,47.2620988 222.003815,46.5770385 C221.95987,45.9499628 222.293497,45.2237521 223.111423,44.971706 Z",
    id: "Shape-Copy-5",
    fill: "#A1A9B5",
    fillRule: "nonzero",
    transform: "translate(225.500000, 45.500000) scale(-1, 1) translate(-225.500000, -45.500000) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10-Copy",
    transform: "translate(185.000000, 34.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.59547453,1.90598434 L2.67151927,1.90598434 C2.67151927,0.853530287 3.59361146,0 4.73189366,0 C5.86937959,0 6.79186992,0.85316191 6.79186992,1.90598434 L6.86791465,1.90598434 C8.30121858,1.90598434 9.46299104,2.9809094 9.46299104,4.30706781 C9.46299104,5.63322622 8.30121858,6.70741453 6.86791465,6.70741453 L2.59507639,6.70741453 C1.16177246,6.70741453 0,5.63322622 0,4.30706781 C0,2.9809094 1.1621706,1.90598434 2.59547453,1.90598434 Z",
    id: "Shape",
    fill: "#A1A9B5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.73149552,
    y1: 2.14951651,
    x2: 4.73149552,
    y2: 11.33169,
    id: "Shape",
    stroke: "#2C3440",
    strokeWidth: 0.5,
    fill: "#2C3440",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.73149552,
    y1: 5.61910277,
    x2: 6.96784779,
    y2: 3.65417806,
    id: "Shape",
    stroke: "#2C3440",
    strokeWidth: 0.5,
    fill: "#2C3440",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.74742112,
    y1: 4.87276334,
    x2: 2.36574776,
    y2: 3.22427476,
    id: "Shape",
    stroke: "#2C3440",
    strokeWidth: 0.5,
    fill: "#2C3440",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-10-Copy-2",
    transform: "translate(0.000000, 34.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.59547453,1.90598434 L2.67151927,1.90598434 C2.67151927,0.853530287 3.59361146,0 4.73189366,0 C5.86937959,0 6.79186992,0.85316191 6.79186992,1.90598434 L6.86791465,1.90598434 C8.30121858,1.90598434 9.46299104,2.9809094 9.46299104,4.30706781 C9.46299104,5.63322622 8.30121858,6.70741453 6.86791465,6.70741453 L2.59507639,6.70741453 C1.16177246,6.70741453 0,5.63322622 0,4.30706781 C0,2.9809094 1.1621706,1.90598434 2.59547453,1.90598434 Z",
    id: "Shape",
    fill: "#A1A9B5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.73149552,
    y1: 2.14951651,
    x2: 4.73149552,
    y2: 11.33169,
    id: "Shape",
    stroke: "#2C3440",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.73149552,
    y1: 5.61910277,
    x2: 6.96784779,
    y2: 3.65417806,
    id: "Shape",
    stroke: "#2C3440",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.74742112,
    y1: 4.87276334,
    x2: 2.36574776,
    y2: 3.22427476,
    id: "Shape",
    stroke: "#2C3440",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M184.111423,44.971706 C184.080033,44.3778312 184.374199,43.9817588 184.695271,43.7961145 C185.067014,43.5833483 185.516335,43.5978445 185.894805,43.8171573 C186.141887,43.4636381 186.455335,43.2143977 186.816316,43.0900114 C187.226176,42.9473879 187.671909,42.9749773 188.071455,43.1676359 C188.710908,43.4753286 189.188031,44.2080859 188.990276,45.0764525 C189.843179,45.4692516 190.065597,46.2090232 189.984432,46.7631505 C189.879052,47.4743974 189.318971,47.9906476 188.652164,47.9906476 C188.606425,47.9915829 186.101977,48 184.582716,48 C183.567036,48 183.052245,47.2620988 183.003815,46.5770385 C182.95987,45.9499628 183.293497,45.2237521 184.111423,44.971706 Z",
    id: "Shape-Copy-6",
    fill: "#A1A9B5",
    fillRule: "nonzero",
    transform: "translate(186.500000, 45.500000) scale(-1, 1) translate(-186.500000, -45.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.111423,44.971706 C180.080033,44.3778312 180.374199,43.9817588 180.695271,43.7961145 C181.067014,43.5833483 181.516335,43.5978445 181.894805,43.8171573 C182.141887,43.4636381 182.455335,43.2143977 182.816316,43.0900114 C183.226176,42.9473879 183.671909,42.9749773 184.071455,43.1676359 C184.710908,43.4753286 185.188031,44.2080859 184.990276,45.0764525 C185.843179,45.4692516 186.065597,46.2090232 185.984432,46.7631505 C185.879052,47.4743974 185.318971,47.9906476 184.652164,47.9906476 C184.606425,47.9915829 182.101977,48 180.582716,48 C179.567036,48 179.052245,47.2620988 179.003815,46.5770385 C178.95987,45.9499628 179.293497,45.2237521 180.111423,44.971706 Z",
    id: "Shape-Copy-7",
    fill: "#A1A9B5",
    fillRule: "nonzero",
    transform: "translate(182.500000, 45.500000) scale(-1, 1) translate(-182.500000, -45.500000) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(24.500000, 24.000000) scale(-1, 1) translate(-24.500000, -24.000000) translate(8.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2122927,0.644137174 L1.46283216,12.8304295 L30.9617532,12.8304295 L16.2122927,0.644137174 Z",
    id: "Triangle",
    stroke: "#2C3440",
    strokeWidth: 0.993145595,
    fill: "#88909C",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#2C3440",
    strokeWidth: 0.5,
    fillRule: "nonzero",
    cx: 16.3198267,
    cy: 7.34916245,
    rx: 2.22328175,
    ry: 2.22194398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3403424,12.7787032 L2.08424294,12.7787032 L2.08424294,47.25258 L30.3403424,47.25258 L30.3403424,12.7787032 Z",
    id: "Rectangle-path",
    stroke: "#2C3440",
    strokeWidth: 0.993145595,
    fill: "#88909C",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path",
    fill: "#2C3440",
    fillRule: "nonzero",
    points: "6.31916567 18.085825 12.986273 18.085825 12.986273 18.3341114 6.31916567 18.3341114"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path-Copy-2",
    fill: "#2C3440",
    fillRule: "nonzero",
    points: "6.31916567 33.5623438 12.986273 33.5623438 12.986273 33.8106302 6.31916567 33.8106302"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path-Copy",
    fill: "#2C3440",
    fillRule: "nonzero",
    points: "19.4383123 18.085825 26.1054197 18.085825 26.1054197 18.3341114 19.4383123 18.3341114"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path",
    fill: "#2C3440",
    fillRule: "nonzero",
    points: "8.03970949 17.6559217 11.2657292 17.6559217 11.2657292 18.3007766 8.03970949 18.3007766"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path-Copy",
    fill: "#2C3440",
    fillRule: "nonzero",
    x: 21.1588562,
    y: 17.6559217,
    width: 3.22601967,
    height: 1
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path-Copy-3",
    fill: "#2C3440",
    fillRule: "nonzero",
    points: "19.4383123 33.5623438 26.1054197 33.5623438 26.1054197 33.8106302 19.4383123 33.8106302"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path-Copy-2",
    fill: "#2C3440",
    fillRule: "nonzero",
    points: "8.03970949 33.1324405 11.2657292 33.1324405 11.2657292 33.7772955 8.03970949 33.7772955"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path-Copy-3",
    fill: "#2C3440",
    fillRule: "nonzero",
    points: "21.1588562 33.1324405 24.3848758 33.1324405 24.3848758 33.7772955 21.1588562 33.7772955"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path",
    fill: "#2C3440",
    fillRule: "nonzero",
    points: "6.31916567 26.683891 12.986273 26.683891 12.986273 26.9321774 6.31916567 26.9321774"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path-Copy-2",
    fill: "#2C3440",
    fillRule: "nonzero",
    points: "6.31916567 42.1604099 12.986273 42.1604099 12.986273 42.4086963 6.31916567 42.4086963"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path-Copy",
    fill: "#2C3440",
    fillRule: "nonzero",
    points: "19.4383123 26.683891 26.1054197 26.683891 26.1054197 26.9321774 19.4383123 26.9321774"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path-Copy-3",
    fill: "#2C3440",
    fillRule: "nonzero",
    points: "19.4383123 42.1604099 26.1054197 42.1604099 26.1054197 42.4086963 19.4383123 42.4086963"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path",
    fill: "#2C3440",
    fillRule: "nonzero",
    points: "6.31916567 27.1137943 12.986273 27.1137943 12.986273 27.3620807 6.31916567 27.3620807"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path-Copy-2",
    fill: "#2C3440",
    fillRule: "nonzero",
    points: "6.31916567 42.5903132 12.986273 42.5903132 12.986273 42.8385996 6.31916567 42.8385996"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path-Copy",
    fill: "#2C3440",
    fillRule: "nonzero",
    points: "19.4383123 27.1137943 26.1054197 27.1137943 26.1054197 27.3620807 19.4383123 27.3620807"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path-Copy-3",
    fill: "#2C3440",
    fillRule: "nonzero",
    points: "19.4383123 42.5903132 26.1054197 42.5903132 26.1054197 42.8385996 19.4383123 42.8385996"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(7.179438, 18.945632)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-path",
    transform: "translate(13.119147, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#2C3440",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -0.107533989,
    y1: 6.98592865,
    x2: 5.26916547,
    y2: 3.76165389,
    id: "Line-2",
    stroke: "#646C78",
    strokeWidth: 0.5,
    fill: "#D8D8D8",
    strokeLinecap: "square",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -0.107533989,
    y1: 7.84573525,
    x2: 5.26916547,
    y2: 4.62146049,
    id: "Line-2-Copy",
    stroke: "#646C78",
    strokeWidth: 0.5,
    fill: "#D8D8D8",
    strokeLinecap: "square",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-path"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#2C3440",
    fillRule: "nonzero",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -0.107533989,
    y1: 6.98592865,
    x2: 5.26916547,
    y2: 3.76165389,
    id: "Line-2",
    stroke: "#646C78",
    strokeWidth: 0.5,
    fill: "#D8D8D8",
    strokeLinecap: "square",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -0.107533989,
    y1: 7.84573525,
    x2: 5.26916547,
    y2: 4.62146049,
    id: "Line-2-Copy",
    stroke: "#646C78",
    strokeWidth: 0.5,
    fill: "#D8D8D8",
    strokeLinecap: "square",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-path",
    transform: "translate(13.119147, 15.476519)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#2C3440",
    fillRule: "nonzero",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -0.107533989,
    y1: 6.98592865,
    x2: 5.26916547,
    y2: 3.76165389,
    id: "Line-2",
    stroke: "#646C78",
    strokeWidth: 0.5,
    fill: "#D8D8D8",
    strokeLinecap: "square",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -0.107533989,
    y1: 7.84573525,
    x2: 5.26916547,
    y2: 4.62146049,
    id: "Line-2-Copy",
    stroke: "#646C78",
    strokeWidth: 0.5,
    fill: "#D8D8D8",
    strokeLinecap: "square",
    mask: "url(#mask-6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-path",
    transform: "translate(0.000000, 15.476519)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#2C3440",
    fillRule: "nonzero",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -0.107533989,
    y1: 6.98592865,
    x2: 5.26916547,
    y2: 3.76165389,
    id: "Line-2",
    stroke: "#646C78",
    strokeWidth: 0.5,
    fill: "#D8D8D8",
    strokeLinecap: "square",
    mask: "url(#mask-8)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -0.107533989,
    y1: 7.84573525,
    x2: 5.26916547,
    y2: 4.62146049,
    id: "Line-2-Copy",
    stroke: "#646C78",
    strokeWidth: 0.5,
    fill: "#D8D8D8",
    strokeLinecap: "square",
    mask: "url(#mask-8)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    transform: "translate(168.500000, 29.000000) scale(-1, 1) translate(-168.500000, -29.000000) translate(151.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.333488,2.86104096 L3.07738854,2.86104096 L3.07738854,37.3349177 L31.333488,37.3349177 L31.333488,2.86104096 Z",
    id: "Rectangle-path",
    stroke: "#2C3440",
    strokeWidth: 0.993145595,
    fill: "#88909C",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path",
    stroke: "#2C3440",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillRule: "nonzero",
    points: "6.66710733 22.14002 27.9588372 22.14002 27.9588372 37.8314905 6.66710733 37.8314905"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path",
    stroke: "#2C3440",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillRule: "nonzero",
    points: "13.5492826 25.7941981 21.0766619 25.7941981 21.0766619 37.8314905 13.5492826 37.8314905"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.3129723,
    y1: 25.9016739,
    x2: 17.3129723,
    y2: 37.7259686,
    id: "Line-3",
    stroke: "#2C3440",
    strokeWidth: 0.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(6.021903, 20.205455)",
    stroke: "#2C3440",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.000000, 1.954929)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.281341109,0.25 C0.329688998,0.439176056 0.431574006,0.608082344 0.570158963,0.741385199 C0.770998941,0.934570254 1.04866641,1.0532858 1.35492826,1.0532858 C1.66119012,1.0532858 1.93885759,0.934570254 2.13969756,0.741385199 C2.27828252,0.608082344 2.38016753,0.439176056 2.42851542,0.25 L0.281341109,0.25 Z",
    id: "Oval-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.76537626,0.25 C2.81372415,0.439176056 2.91560916,0.608082344 3.05419411,0.741385199 C3.25503409,0.934570254 3.53270156,1.0532858 3.83896341,1.0532858 C4.14522527,1.0532858 4.42289273,0.934570254 4.62373271,0.741385199 C4.76231767,0.608082344 4.86420268,0.439176056 4.91255057,0.25 L2.76537626,0.25 Z",
    id: "Oval-2-Copy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.24941141,0.25 C5.2977593,0.439176056 5.3996443,0.608082344 5.53822926,0.741385199 C5.73906924,0.934570254 6.01673671,1.0532858 6.32299856,1.0532858 C6.62926042,1.0532858 6.90692788,0.934570254 7.10776786,0.741385199 C7.24635282,0.608082344 7.34823783,0.439176056 7.39658572,0.25 L5.24941141,0.25 Z",
    id: "Oval-2-Copy-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.73344656,0.25 C7.78179445,0.439176056 7.88367945,0.608082344 8.02226441,0.741385199 C8.22310439,0.934570254 8.50077186,1.0532858 8.80703371,1.0532858 C9.11329557,1.0532858 9.39096303,0.934570254 9.59180301,0.741385199 C9.73038797,0.608082344 9.83227298,0.439176056 9.88062087,0.25 L7.73344656,0.25 Z",
    id: "Oval-2-Copy-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2174817,0.25 C10.2658296,0.439176056 10.3677146,0.608082344 10.5062996,0.741385199 C10.7071395,0.934570254 10.984807,1.0532858 11.2910689,1.0532858 C11.5973307,1.0532858 11.8749982,0.934570254 12.0758382,0.741385199 C12.2144231,0.608082344 12.3163081,0.439176056 12.364656,0.25 L10.2174817,0.25 Z",
    id: "Oval-2-Copy-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7015169,0.25 C12.7498647,0.439176056 12.8517498,0.608082344 12.9903347,0.741385199 C13.1911747,0.934570254 13.4688422,1.0532858 13.775104,1.0532858 C14.0813659,1.0532858 14.3590333,0.934570254 14.5598733,0.741385199 C14.6984583,0.608082344 14.8003433,0.439176056 14.8486912,0.25 L12.7015169,0.25 Z",
    id: "Oval-2-Copy-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.185552,0.25 C15.2338999,0.439176056 15.3357849,0.608082344 15.4743699,0.741385199 C15.6752098,0.934570254 15.9528773,1.0532858 16.2591392,1.0532858 C16.565401,1.0532858 16.8430685,0.934570254 17.0439085,0.741385199 C17.1824934,0.608082344 17.2843784,0.439176056 17.3327263,0.25 L15.185552,0.25 Z",
    id: "Oval-2-Copy-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6695872,0.25 C17.717935,0.439176056 17.8198201,0.608082344 17.958405,0.741385199 C18.159245,0.934570254 18.4369125,1.0532858 18.7431743,1.0532858 C19.0494362,1.0532858 19.3271036,0.934570254 19.5279436,0.741385199 C19.6665286,0.608082344 19.7684136,0.439176056 19.8167615,0.25 L17.6695872,0.25 Z",
    id: "Oval-2-Copy-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1536223,0.25 C20.2019702,0.439176056 20.3038552,0.608082344 20.4424402,0.741385199 C20.6432801,0.934570254 20.9209476,1.0532858 21.2272095,1.0532858 C21.5334713,1.0532858 21.8111388,0.934570254 22.0119788,0.741385199 C22.1505637,0.608082344 22.2524487,0.439176056 22.3007966,0.25 L20.1536223,0.25 Z",
    id: "Oval-2-Copy-8"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M2.93254513,0.25 L0.874577097,0.25 L0.35479016,1.7049287 L2.53842097,1.7049287 L2.93254513,0.25 Z",
    id: "Rectangle-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.28465666,0.25 L3.21631726,0.25 L2.81076921,1.7049287 L5.00477138,1.7049287 L5.28465666,0.25 Z",
    id: "Rectangle-6-Copy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.63531044,0.25 L5.55943381,0.25 L5.26812465,1.7049287 L7.46966405,1.7049287 L7.63531044,0.25 Z",
    id: "Rectangle-6-Copy-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.98445457,0.25 L7.90400167,0.25 L7.72693139,1.7049287 L9.93304707,1.7049287 L9.98445457,0.25 Z",
    id: "Rectangle-6-Copy-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3320626,0.25 L10.2500751,0.25 L10.1872437,1.7049287 L12.394894,1.7049287 L12.3320626,0.25 Z",
    id: "Rectangle-6-Copy-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6781361,0.25 L12.5976831,0.25 L12.6490906,1.7049287 L14.8552063,1.7049287 L14.6781361,0.25 Z",
    id: "Rectangle-6-Copy-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0227039,0.25 L14.9468273,0.25 L15.1124737,1.7049287 L17.3140131,1.7049287 L17.0227039,0.25 Z",
    id: "Rectangle-6-Copy-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3658205,0.25 L17.2974811,0.25 L17.5773663,1.7049287 L19.7713685,1.7049287 L19.3658205,0.25 Z",
    id: "Rectangle-6-Copy-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7075606,0.25 L19.6495926,0.25 L20.0437168,1.7049287 L22.2273476,1.7049287 L21.7075606,0.25 Z",
    id: "Rectangle-6-Copy-8"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path",
    fill: "#2C3440",
    fillRule: "nonzero",
    points: "7.31231126 8.16816273 13.9794186 8.16816273 13.9794186 8.41644913 7.31231126 8.41644913"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path-Copy",
    fill: "#2C3440",
    fillRule: "nonzero",
    points: "20.4314579 8.16816273 27.0985653 8.16816273 27.0985653 8.41644913 20.4314579 8.41644913"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path",
    fill: "#2C3440",
    fillRule: "nonzero",
    points: "9.03285509 7.73825943 12.2588748 7.73825943 12.2588748 8.38311438 9.03285509 8.38311438"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path-Copy",
    fill: "#2C3440",
    fillRule: "nonzero",
    points: "22.1520018 7.73825943 25.3780214 7.73825943 25.3780214 8.38311438 22.1520018 8.38311438"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path",
    fill: "#2C3440",
    fillRule: "nonzero",
    points: "7.31231126 16.7662288 13.9794186 16.7662288 13.9794186 17.0145152 7.31231126 17.0145152"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path-Copy",
    fill: "#2C3440",
    fillRule: "nonzero",
    points: "20.4314579 16.7662288 27.0985653 16.7662288 27.0985653 17.0145152 20.4314579 17.0145152"
  }), /*#__PURE__*/React.createElement("path", {
    d: "",
    id: "Rectangle-path",
    stroke: "#001D44",
    strokeWidth: 0.5,
    fill: "#0055B9",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path-Copy",
    fill: "#2C3440",
    fillRule: "nonzero",
    points: "20.4314579 17.1961321 27.0985653 17.1961321 27.0985653 17.4444185 20.4314579 17.4444185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9143037,0.496572797 L0.496572797,0.496572797 L0.496572797,2.29779866 L33.9143037,2.29779866 L33.9143037,0.496572797 Z",
    id: "Rectangle-path",
    stroke: "#2C3440",
    strokeWidth: 0.993145595,
    fill: "#88909C",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(8.172583, 9.027969)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-path",
    transform: "translate(13.119147, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#2C3440",
    fillRule: "nonzero",
    xlinkHref: "#path-9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -0.107533989,
    y1: 6.98592865,
    x2: 5.26916547,
    y2: 3.76165389,
    id: "Line-2",
    stroke: "#646C78",
    strokeWidth: 0.5,
    strokeLinecap: "square",
    mask: "url(#mask-10)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -0.107533989,
    y1: 7.84573525,
    x2: 5.26916547,
    y2: 4.62146049,
    id: "Line-2-Copy",
    stroke: "#646C78",
    strokeWidth: 0.5,
    strokeLinecap: "square",
    mask: "url(#mask-10)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-path"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#2C3440",
    fillRule: "nonzero",
    xlinkHref: "#path-11"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -0.107533989,
    y1: 6.98592865,
    x2: 5.26916547,
    y2: 3.76165389,
    id: "Line-2",
    stroke: "#646C78",
    strokeWidth: 0.5,
    strokeLinecap: "square",
    mask: "url(#mask-12)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -0.107533989,
    y1: 7.84573525,
    x2: 5.26916547,
    y2: 4.62146049,
    id: "Line-2-Copy",
    stroke: "#646C78",
    strokeWidth: 0.5,
    strokeLinecap: "square",
    mask: "url(#mask-12)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-path",
    transform: "translate(0.645204, 18.915745)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#2C3440",
    fillRule: "nonzero",
    xlinkHref: "#path-13"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -1.39794186,
    y1: 6.98592865,
    x2: 3.9787576,
    y2: 3.76165389,
    id: "Line-2",
    stroke: "#646C78",
    strokeWidth: 0.5,
    strokeLinecap: "square",
    mask: "url(#mask-14)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -1.39794186,
    y1: 7.84573525,
    x2: 3.9787576,
    y2: 4.62146049,
    id: "Line-2-Copy",
    stroke: "#646C78",
    strokeWidth: 0.5,
    strokeLinecap: "square",
    mask: "url(#mask-14)"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path",
    fill: "#2C3440",
    fillRule: "nonzero",
    points: "0 18.0559387 3.87122361 18.0559387 3.87122361 18.3042251 0 18.3042251"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path",
    fill: "#2C3440",
    fillRule: "nonzero",
    points: "1.07533989 17.6260354 3.0109517 17.6260354 3.0109517 18.2708903 1.07533989 18.2708903"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path",
    fill: "#2C3440",
    fillRule: "nonzero",
    points: "0 26.439053 3.87122361 26.439053 3.87122361 26.6873394 0 26.6873394"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path",
    fill: "#2C3440",
    fillRule: "nonzero",
    points: "0 26.8689563 3.87122361 26.8689563 3.87122361 27.1172427 0 27.1172427"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-path-Copy-4",
    transform: "translate(15.054758, 18.915745)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-16",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-15"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#2C3440",
    fillRule: "nonzero",
    xlinkHref: "#path-15"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -1.39794186,
    y1: 6.98592865,
    x2: 3.9787576,
    y2: 3.76165389,
    id: "Line-2",
    stroke: "#646C78",
    strokeWidth: 0.5,
    strokeLinecap: "square",
    mask: "url(#mask-16)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -1.39794186,
    y1: 7.84573525,
    x2: 3.9787576,
    y2: 4.62146049,
    id: "Line-2-Copy",
    stroke: "#646C78",
    strokeWidth: 0.5,
    strokeLinecap: "square",
    mask: "url(#mask-16)"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path",
    fill: "#2C3440",
    fillRule: "nonzero",
    points: "14.4095545 18.0559387 18.2807782 18.0559387 18.2807782 18.3042251 14.4095545 18.3042251"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path",
    fill: "#2C3440",
    fillRule: "nonzero",
    points: "15.4848944 17.6260354 17.4205062 17.6260354 17.4205062 18.2708903 15.4848944 18.2708903"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path",
    fill: "#2C3440",
    fillRule: "nonzero",
    points: "14.4095545 26.439053 18.2807782 26.439053 18.2807782 26.6873394 14.4095545 26.6873394"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path",
    fill: "#2C3440",
    fillRule: "nonzero",
    points: "14.4095545 26.8689563 18.2807782 26.8689563 18.2807782 27.1172427 14.4095545 27.1172427"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(240.500000, 27.000000) scale(-1, 1) translate(-240.500000, -27.000000) translate(223.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-2",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.333488,6.66350117 L3.07738854,6.66350117 L3.07738854,41.1373779 L31.333488,41.1373779 L31.333488,6.66350117 Z",
    id: "Rectangle-path",
    stroke: "#2C3440",
    strokeWidth: 0.993145595,
    fill: "#88909C",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path",
    stroke: "#2C3440",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillRule: "nonzero",
    points: "13.5492826 27.8770451 21.2917299 27.8770451 21.2917299 41.6339507 13.5492826 41.6339507"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.3129723,
    y1: 27.9845209,
    x2: 17.3129723,
    y2: 41.5284289,
    id: "Line-3",
    stroke: "#2C3440",
    strokeWidth: 0.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6298333,0.496572797 L8.78104326,0.496572797 L1.38278845,6.59683168 L33.0280881,6.59683168 L25.6298333,0.496572797 Z",
    id: "Rectangle-path",
    stroke: "#2C3440",
    strokeWidth: 0.993145595,
    fill: "#88909C",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(5.806835, 12.830430)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-path"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-18",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-17"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#2C3440",
    fillRule: "nonzero",
    xlinkHref: "#path-17"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -0.107533989,
    y1: 6.98592865,
    x2: 5.26916547,
    y2: 3.76165389,
    id: "Line-2",
    stroke: "#646C78",
    strokeWidth: 0.5,
    strokeLinecap: "square",
    mask: "url(#mask-18)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -0.107533989,
    y1: 7.84573525,
    x2: 5.26916547,
    y2: 4.62146049,
    id: "Line-2-Copy",
    stroke: "#646C78",
    strokeWidth: 0.5,
    strokeLinecap: "square",
    mask: "url(#mask-18)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy",
    transform: "translate(4.946564, 11.540720)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path",
    fill: "#2C3440",
    fillRule: "nonzero",
    points: "0 18.485842 6.66710733 18.485842 6.66710733 18.7341284 0 18.7341284"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path",
    fill: "#2C3440",
    fillRule: "nonzero",
    points: "1.72054383 18.0559387 4.9465635 18.0559387 4.9465635 18.7007936 1.72054383 18.7007936"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path-Copy-5",
    fill: "#2C3440",
    fillRule: "nonzero",
    points: "1.72054383 0 4.9465635 0 4.9465635 0.644854952 1.72054383 0.644854952"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path",
    fill: "#2C3440",
    fillRule: "nonzero",
    points: "0 27.083908 6.66710733 27.083908 6.66710733 27.3321944 0 27.3321944"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path",
    fill: "#2C3440",
    fillRule: "nonzero",
    points: "0 27.5138113 6.66710733 27.5138113 6.66710733 27.7620977 0 27.7620977"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-path",
    transform: "translate(0.860272, 19.345649)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-20",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-19"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#2C3440",
    fillRule: "nonzero",
    xlinkHref: "#path-19"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -0.107533989,
    y1: 6.98592865,
    x2: 5.26916547,
    y2: 3.76165389,
    id: "Line-2",
    stroke: "#646C78",
    strokeWidth: 0.5,
    strokeLinecap: "square",
    mask: "url(#mask-20)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -0.107533989,
    y1: 7.84573525,
    x2: 5.26916547,
    y2: 4.62146049,
    id: "Line-2-Copy",
    stroke: "#646C78",
    strokeWidth: 0.5,
    strokeLinecap: "square",
    mask: "url(#mask-20)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(5.161631, 11.970623)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path-Copy",
    fill: "#2C3440",
    fillRule: "nonzero",
    points: "0 0 24.3026815 0 24.3026815 0.248286399 0 0.248286399"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-path",
    transform: "translate(9.678059, 0.859807)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-22",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-21"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#2C3440",
    fillRule: "nonzero",
    xlinkHref: "#path-21"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -0.107533989,
    y1: 6.98592865,
    x2: 5.26916547,
    y2: 3.76165389,
    id: "Line-2",
    stroke: "#646C78",
    strokeWidth: 0.5,
    strokeLinecap: "square",
    mask: "url(#mask-22)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -0.107533989,
    y1: 7.84573525,
    x2: 5.26916547,
    y2: 4.62146049,
    id: "Line-2-Copy",
    stroke: "#646C78",
    strokeWidth: 0.5,
    strokeLinecap: "square",
    mask: "url(#mask-22)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-4-Copy",
    transform: "translate(4.946564, 12.830430)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path-Copy",
    fill: "#2C3440",
    fillRule: "nonzero",
    points: "0 7.73825943 24.5177495 7.73825943 24.5177495 7.98654582 0 7.98654582"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path-Copy",
    fill: "#2C3440",
    fillRule: "nonzero",
    points: "0 8.16816273 24.5177495 8.16816273 24.5177495 8.41644913 0 8.41644913"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-path",
    transform: "translate(18.710914, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-24",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-23"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#2C3440",
    fillRule: "nonzero",
    xlinkHref: "#path-23"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -0.107533989,
    y1: 6.98592865,
    x2: 5.26916547,
    y2: 3.76165389,
    id: "Line-2",
    stroke: "#646C78",
    strokeWidth: 0.5,
    strokeLinecap: "square",
    mask: "url(#mask-24)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -0.107533989,
    y1: 7.84573525,
    x2: 5.26916547,
    y2: 4.62146049,
    id: "Line-2-Copy",
    stroke: "#646C78",
    strokeWidth: 0.5,
    strokeLinecap: "square",
    mask: "url(#mask-24)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-4-Copy-2",
    transform: "translate(12.258875, 11.540720)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path-Copy",
    fill: "#2C3440",
    fillRule: "nonzero",
    points: "10.5383309 18.485842 17.2054383 18.485842 17.2054383 18.7341284 10.5383309 18.7341284"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path-Copy",
    fill: "#2C3440",
    fillRule: "nonzero",
    x: 12.2588748,
    y: 18.0559387,
    width: 3.22601967,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path-Copy-8",
    stroke: "#2C3440",
    strokeWidth: 0.5,
    fillRule: "nonzero",
    x: 0.25,
    y: 14.8667122,
    width: 9.60819498,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path-Copy-6",
    fill: "#2C3440",
    fillRule: "nonzero",
    x: 12.2588748,
    y: 0,
    width: 3.22601967,
    height: 1
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path-Copy-7",
    fill: "#2C3440",
    fillRule: "nonzero",
    points: "3.44108765 0 6.66710733 0 6.66710733 0.644854952 3.44108765 0.644854952"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path-Copy",
    fill: "#2C3440",
    fillRule: "nonzero",
    points: "10.5383309 27.083908 17.2054383 27.083908 17.2054383 27.3321944 10.5383309 27.3321944"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path-Copy",
    fill: "#2C3440",
    fillRule: "nonzero",
    points: "10.5383309 27.5138113 17.2054383 27.5138113 17.2054383 27.7620977 10.5383309 27.7620977"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-path",
    transform: "translate(11.398603, 19.345649)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-26",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-25"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#2C3440",
    fillRule: "nonzero",
    xlinkHref: "#path-25"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -0.107533989,
    y1: 6.98592865,
    x2: 5.26916547,
    y2: 3.76165389,
    id: "Line-2",
    stroke: "#646C78",
    strokeWidth: 0.5,
    strokeLinecap: "square",
    mask: "url(#mask-26)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -0.107533989,
    y1: 7.84573525,
    x2: 5.26916547,
    y2: 4.62146049,
    id: "Line-2-Copy",
    stroke: "#646C78",
    strokeWidth: 0.5,
    strokeLinecap: "square",
    mask: "url(#mask-26)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(70.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.73149552,22.3549717 C7.34462834,22.3549717 9.46299104,20.2166628 9.46299104,14.0435078 C9.46299104,9.9280712 7.88582587,5.24690192 4.73149552,0 C1.57716517,5.24690192 0,9.9280712 0,14.0435078 C0,20.2166628 2.1183627,22.3549717 4.73149552,22.3549717 Z",
    id: "Oval-Copy-2",
    fill: "#A1A9B5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.62396153,
    y1: 32.5651751,
    x2: 4.62396153,
    y2: 10.2102034,
    id: "Line-Copy-2",
    stroke: "#2C3440",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.62345603,
    y1: 19.3926795,
    x2: 1.86908129,
    y2: 16.6397945,
    id: "Line-Copy-2",
    stroke: "#2C3440",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.62345603,
    y1: 13.1590816,
    x2: 3.13690502,
    y2: 11.6733346,
    id: "Line-Copy-4",
    stroke: "#2C3440",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.77413581,
    y1: 15.7385014,
    x2: 4.54506429,
    y2: 13.5106355,
    id: "Line-Copy-3",
    stroke: "#2C3440",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    transform: "translate(5.699301, 14.616712) scale(-1, 1) translate(-5.699301, -14.616712) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(74.000000, 43.000000)",
    fill: "#A1A9B5",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.08142574,1.83874852 C1.05088325,1.2849203 1.33710997,0.915556133 1.64951595,0.742430305 C2.01122624,0.544011535 2.44842009,0.557530176 2.81667519,0.762054139 C3.05708818,0.432373721 3.3620767,0.199940305 3.71331528,0.0839416389 C4.11211286,-0.0490643499 4.54581614,-0.0233353225 4.93457834,0.156331784 C5.55677239,0.443275851 6.02101815,1.12662137 5.8286005,1.93643161 C6.65848344,2.30274318 6.87489876,2.99262998 6.79592462,3.50939096 C6.69338914,4.17267656 6.14842395,4.65411463 5.49961431,4.65411463 C5.45510955,4.6549868 3.01825559,4.66283634 1.53999933,4.66283634 C0.551731789,4.66283634 0.0508350403,3.97469388 0.00371234962,3.33582904 C-0.0390471289,2.75103878 0.285575851,2.07379845 1.08142574,1.83874852 Z",
    id: "Shape-Copy",
    transform: "translate(3.405536, 2.331418) scale(-1, 1) translate(-3.405536, -2.331418) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.01018314,1.83874852 C3.97964065,1.2849203 4.26586737,0.915556133 4.57827335,0.742430305 C4.93998364,0.544011535 5.37717749,0.557530176 5.74543259,0.762054139 C5.98584558,0.432373721 6.2908341,0.199940305 6.64207267,0.0839416389 C7.04087026,-0.0490643499 7.47457354,-0.0233353225 7.86333574,0.156331784 C8.48552979,0.443275851 8.94977555,1.12662137 8.7573579,1.93643161 C9.58724084,2.30274318 9.80365616,2.99262998 9.72468202,3.50939096 C9.62214654,4.17267656 9.07718135,4.65411463 8.42837171,4.65411463 C8.38386694,4.6549868 5.94701299,4.66283634 4.46875673,4.66283634 C3.48048919,4.66283634 2.97959244,3.97469388 2.93246975,3.33582904 C2.88971027,2.75103878 3.21433325,2.07379845 4.01018314,1.83874852 Z",
    id: "Shape-Copy-2",
    transform: "translate(6.334294, 2.331418) scale(-1, 1) translate(-6.334294, -2.331418) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(3.000000, 43.000000)",
    fill: "#A1A9B5",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.08142574,1.83874852 C1.05088325,1.2849203 1.33710997,0.915556133 1.64951595,0.742430305 C2.01122624,0.544011535 2.44842009,0.557530176 2.81667519,0.762054139 C3.05708818,0.432373721 3.3620767,0.199940305 3.71331528,0.0839416389 C4.11211286,-0.0490643499 4.54581614,-0.0233353225 4.93457834,0.156331784 C5.55677239,0.443275851 6.02101815,1.12662137 5.8286005,1.93643161 C6.65848344,2.30274318 6.87489876,2.99262998 6.79592462,3.50939096 C6.69338914,4.17267656 6.14842395,4.65411463 5.49961431,4.65411463 C5.45510955,4.6549868 3.01825559,4.66283634 1.53999933,4.66283634 C0.551731789,4.66283634 0.0508350403,3.97469388 0.00371234962,3.33582904 C-0.0390471289,2.75103878 0.285575851,2.07379845 1.08142574,1.83874852 Z",
    id: "Shape-Copy",
    transform: "translate(3.405536, 2.331418) scale(-1, 1) translate(-3.405536, -2.331418) "
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M216,28.7858796 C216,21.6138485 221.817226,15.7997685 228.993139,15.7997685 C231.6898,15.7997685 234.194587,16.6208373 236.270885,18.0264888 C240.533855,7.45810407 250.891416,0 262.991852,0 C271.989317,0 280.023164,4.12350617 285.304762,10.582854 C287.080711,10.0346183 288.969433,9.73958333 290.927101,9.73958333 C301.451773,9.73958333 309.983705,18.2669006 309.983705,28.7858796 L309.983705,28.7858796 Z",
    id: "Combined-Shape",
    fillOpacity: 0.5,
    fill: "#2C3440",
    transform: "translate(262.991852, 14.392940) scale(-1, 1) translate(-262.991852, -14.392940) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,150 C41,147.891276 42.5670034,146 44.5,146 C44.8117736,146 45.1140261,146.049201 45.4017182,146.140579 L45.4488645,146.038773 C46.0490545,144.821821 47.1905507,144 48.5,144 C48.8595425,144 49.2064227,144.061958 49.532912,144.177042 C50.9622828,142.831492 52.8853235,142 55,142 C58.0031278,142 60.619767,143.676941 61.9878709,146.123534 C63.7196564,146.563225 65,148.132092 65,150 L65,150 Z",
    id: "Combined-Shape-Copy-2",
    fill: "#646C78",
    transform: "translate(53.000000, 146.000000) scale(-1, 1) translate(-53.000000, -146.000000) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(80.000000, 34.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116,50 L30,50 C22.2680135,50 15.2680135,53.1340068 10.2010101,58.2010101 C5.13400675,63.2680135 2,70.2680135 2,78 L2,128 C2,135.731986 5.13400675,142.731986 10.2010101,147.79899 C15.2680135,152.865993 22.2680135,156 30,156 L116,156 C123.731986,156 130.731986,152.865993 135.79899,147.79899 C140.865993,142.731986 144,135.731986 144,128 L144,78 C144,70.2680135 140.865993,63.2680135 135.79899,58.2010101 C130.731986,53.1340068 123.731986,50 116,50 Z",
    id: "Combined-Shape",
    stroke: "#2C3440",
    strokeWidth: 4,
    fill: "#A1A9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.046729,80.5 C69.5820454,80.5 66.4453632,81.9043405 64.1748518,84.1748518 C61.9043405,86.4453632 60.5,89.5820454 60.5,93.046729 C60.5,97.6779896 63.0094571,101.722835 66.742012,103.897022 L66.7468405,119.802333 C66.8052841,121.490548 67.5280084,123.009848 68.6612075,124.107617 C69.7958132,125.206749 71.3422864,125.883178 73.046729,125.883178 C74.7874582,125.883178 76.3633928,125.177608 77.5041451,124.036855 C78.6448973,122.896103 79.3504673,121.320169 79.3504673,119.579439 L79.3512345,103.897145 C83.0839061,101.722988 85.5934579,97.6780771 85.5934579,93.046729 C85.5934579,89.5820454 84.1891175,86.4453632 81.9186061,84.1748518 C79.6480948,81.9043405 76.5114125,80.5 73.046729,80.5 Z",
    id: "Combined-Shape",
    stroke: "#2C3440",
    strokeWidth: 3,
    fill: "#A1A9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,2 C65.2680135,2 58.2680135,5.13400675 53.2010101,10.2010101 C48.1340068,15.2680135 45,22.2680135 45,30 L45,50 L101,50 L101,30 C101,22.2680135 97.8659932,15.2680135 92.7989899,10.2010101 C87.7319865,5.13400675 80.7319865,2 73,2 Z",
    id: "Rectangle-path",
    stroke: "#2C3440",
    strokeWidth: 4,
    fill: "#A1A9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.369159,67.9766355 L100.509346,67.9766355 L100.509346,93.0700935 L222.369159,93.0700935 L222.369159,67.9766355 Z",
    id: "Combined-Shape",
    stroke: "#2C3440",
    strokeWidth: 3,
    fill: "#2C3440"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.876935,84.7810841 C128.126654,84.7810841 128.34724,84.6936822 128.538692,84.5188785 C128.730143,84.3440748 128.825869,84.1318131 128.825869,83.8820935 C128.825869,83.7156137 128.775925,83.549134 128.676037,83.3826542 L128.676037,83.3826542 L127.202692,81.0852336 L129.949607,81.2100935 C130.249271,81.2267414 130.482343,81.1435016 130.648822,80.9603738 C130.815302,80.7772461 130.898542,80.5608224 130.898542,80.3111028 C130.898542,80.0613832 130.815302,79.8449595 130.648822,79.6618318 C130.482343,79.478704 130.249271,79.3954642 129.949607,79.4121121 L129.949607,79.4121121 L127.202692,79.536972 L128.676037,77.2395514 C128.775925,77.0564237 128.825869,76.8899439 128.825869,76.7401121 C128.825869,76.4903925 128.730143,76.2781308 128.538692,76.1033271 C128.34724,75.9285234 128.126654,75.8411215 127.876935,75.8411215 C127.543975,75.8411215 127.294255,76.0076012 127.127776,76.3405607 L127.127776,76.3405607 L125.879178,78.7878131 L124.605607,76.3405607 C124.439128,76.0076012 124.181084,75.8411215 123.831477,75.8411215 C123.581757,75.8411215 123.361171,75.9243614 123.16972,76.0908411 C122.978268,76.2573209 122.882542,76.4654206 122.882542,76.7151402 C122.882542,76.8982679 122.94081,77.0730717 123.057346,77.2395514 L123.057346,77.2395514 L124.530692,79.536972 L121.783776,79.4121121 C121.484112,79.3954642 121.255202,79.478704 121.097047,79.6618318 C120.938891,79.8449595 120.859813,80.0613832 120.859813,80.3111028 C120.859813,80.5608224 120.938891,80.7772461 121.097047,80.9603738 C121.255202,81.1435016 121.484112,81.2267414 121.783776,81.2100935 L121.783776,81.2100935 L124.530692,81.0852336 L123.057346,83.4076262 C122.94081,83.5741059 122.882542,83.7405857 122.882542,83.9070654 C122.882542,84.156785 122.98243,84.3648847 123.182206,84.5313645 C123.381981,84.6978442 123.606729,84.7810841 123.856449,84.7810841 C124.206056,84.7810841 124.455776,84.6229283 124.605607,84.3066168 L124.605607,84.3066168 L125.879178,81.8593645 L127.127776,84.2816449 C127.294255,84.6146044 127.543975,84.7810841 127.876935,84.7810841 Z M145.38228,84.7810841 C145.632,84.7810841 145.852586,84.6936822 146.044037,84.5188785 C146.235489,84.3440748 146.331215,84.1318131 146.331215,83.8820935 C146.331215,83.7156137 146.281271,83.549134 146.181383,83.3826542 L146.181383,83.3826542 L144.708037,81.0852336 L147.454953,81.2100935 C147.754617,81.2267414 147.987688,81.1435016 148.154168,80.9603738 C148.320648,80.7772461 148.403888,80.5608224 148.403888,80.3111028 C148.403888,80.0613832 148.320648,79.8449595 148.154168,79.6618318 C147.987688,79.478704 147.754617,79.3954642 147.454953,79.4121121 L147.454953,79.4121121 L144.708037,79.536972 L146.181383,77.2395514 C146.281271,77.0564237 146.331215,76.8899439 146.331215,76.7401121 C146.331215,76.4903925 146.235489,76.2781308 146.044037,76.1033271 C145.852586,75.9285234 145.632,75.8411215 145.38228,75.8411215 C145.049321,75.8411215 144.799601,76.0076012 144.633121,76.3405607 L144.633121,76.3405607 L143.384523,78.7878131 L142.110953,76.3405607 C141.944474,76.0076012 141.68643,75.8411215 141.336822,75.8411215 C141.087103,75.8411215 140.866517,75.9243614 140.675065,76.0908411 C140.483614,76.2573209 140.387888,76.4654206 140.387888,76.7151402 C140.387888,76.8982679 140.446156,77.0730717 140.562692,77.2395514 L140.562692,77.2395514 L142.036037,79.536972 L139.289121,79.4121121 C138.989458,79.3954642 138.760548,79.478704 138.602393,79.6618318 C138.444237,79.8449595 138.365159,80.0613832 138.365159,80.3111028 C138.365159,80.5608224 138.444237,80.7772461 138.602393,80.9603738 C138.760548,81.1435016 138.989458,81.2267414 139.289121,81.2100935 L139.289121,81.2100935 L142.036037,81.0852336 L140.562692,83.4076262 C140.446156,83.5741059 140.387888,83.7405857 140.387888,83.9070654 C140.387888,84.156785 140.487776,84.3648847 140.687551,84.5313645 C140.887327,84.6978442 141.112075,84.7810841 141.361794,84.7810841 C141.711402,84.7810841 141.961121,84.6229283 142.110953,84.3066168 L142.110953,84.3066168 L143.384523,81.8593645 L144.633121,84.2816449 C144.799601,84.6146044 145.049321,84.7810841 145.38228,84.7810841 Z M162.887626,84.7810841 C163.137346,84.7810841 163.357931,84.6936822 163.549383,84.5188785 C163.740835,84.3440748 163.836561,84.1318131 163.836561,83.8820935 C163.836561,83.7156137 163.786617,83.549134 163.686729,83.3826542 L163.686729,83.3826542 L162.213383,81.0852336 L164.960299,81.2100935 C165.259963,81.2267414 165.493034,81.1435016 165.659514,80.9603738 C165.825994,80.7772461 165.909234,80.5608224 165.909234,80.3111028 C165.909234,80.0613832 165.825994,79.8449595 165.659514,79.6618318 C165.493034,79.478704 165.259963,79.3954642 164.960299,79.4121121 L164.960299,79.4121121 L162.213383,79.536972 L163.686729,77.2395514 C163.786617,77.0564237 163.836561,76.8899439 163.836561,76.7401121 C163.836561,76.4903925 163.740835,76.2781308 163.549383,76.1033271 C163.357931,75.9285234 163.137346,75.8411215 162.887626,75.8411215 C162.554667,75.8411215 162.304947,76.0076012 162.138467,76.3405607 L162.138467,76.3405607 L160.889869,78.7878131 L159.616299,76.3405607 C159.449819,76.0076012 159.191776,75.8411215 158.842168,75.8411215 C158.592449,75.8411215 158.371863,75.9243614 158.180411,76.0908411 C157.98896,76.2573209 157.893234,76.4654206 157.893234,76.7151402 C157.893234,76.8982679 157.951502,77.0730717 158.068037,77.2395514 L158.068037,77.2395514 L159.541383,79.536972 L156.794467,79.4121121 C156.494804,79.3954642 156.265894,79.478704 156.107738,79.6618318 C155.949583,79.8449595 155.870505,80.0613832 155.870505,80.3111028 C155.870505,80.5608224 155.949583,80.7772461 156.107738,80.9603738 C156.265894,81.1435016 156.494804,81.2267414 156.794467,81.2100935 L156.794467,81.2100935 L159.541383,81.0852336 L158.068037,83.4076262 C157.951502,83.5741059 157.893234,83.7405857 157.893234,83.9070654 C157.893234,84.156785 157.993121,84.3648847 158.192897,84.5313645 C158.392673,84.6978442 158.617421,84.7810841 158.86714,84.7810841 C159.216748,84.7810841 159.466467,84.6229283 159.616299,84.3066168 L159.616299,84.3066168 L160.889869,81.8593645 L162.138467,84.2816449 C162.304947,84.6146044 162.554667,84.7810841 162.887626,84.7810841 Z M180.392972,84.7810841 C180.642692,84.7810841 180.863277,84.6936822 181.054729,84.5188785 C181.246181,84.3440748 181.341907,84.1318131 181.341907,83.8820935 C181.341907,83.7156137 181.291963,83.549134 181.192075,83.3826542 L181.192075,83.3826542 L179.718729,81.0852336 L182.465645,81.2100935 C182.765308,81.2267414 182.99838,81.1435016 183.16486,80.9603738 C183.33134,80.7772461 183.414579,80.5608224 183.414579,80.3111028 C183.414579,80.0613832 183.33134,79.8449595 183.16486,79.6618318 C182.99838,79.478704 182.765308,79.3954642 182.465645,79.4121121 L182.465645,79.4121121 L179.718729,79.536972 L181.192075,77.2395514 C181.291963,77.0564237 181.341907,76.8899439 181.341907,76.7401121 C181.341907,76.4903925 181.246181,76.2781308 181.054729,76.1033271 C180.863277,75.9285234 180.642692,75.8411215 180.392972,75.8411215 C180.060012,75.8411215 179.810293,76.0076012 179.643813,76.3405607 L179.643813,76.3405607 L178.395215,78.7878131 L177.121645,76.3405607 C176.955165,76.0076012 176.697121,75.8411215 176.347514,75.8411215 C176.097794,75.8411215 175.877209,75.9243614 175.685757,76.0908411 C175.494305,76.2573209 175.398579,76.4654206 175.398579,76.7151402 C175.398579,76.8982679 175.456847,77.0730717 175.573383,77.2395514 L175.573383,77.2395514 L177.046729,79.536972 L174.299813,79.4121121 C174.00015,79.3954642 173.77124,79.478704 173.613084,79.6618318 C173.454928,79.8449595 173.37585,80.0613832 173.37585,80.3111028 C173.37585,80.5608224 173.454928,80.7772461 173.613084,80.9603738 C173.77124,81.1435016 174.00015,81.2267414 174.299813,81.2100935 L174.299813,81.2100935 L177.046729,81.0852336 L175.573383,83.4076262 C175.456847,83.5741059 175.398579,83.7405857 175.398579,83.9070654 C175.398579,84.156785 175.498467,84.3648847 175.698243,84.5313645 C175.898019,84.6978442 176.122766,84.7810841 176.372486,84.7810841 C176.722093,84.7810841 176.971813,84.6229283 177.121645,84.3066168 L177.121645,84.3066168 L178.395215,81.8593645 L179.643813,84.2816449 C179.810293,84.6146044 180.060012,84.7810841 180.392972,84.7810841 Z M197.898318,84.7810841 C198.148037,84.7810841 198.368623,84.6936822 198.560075,84.5188785 C198.751526,84.3440748 198.847252,84.1318131 198.847252,83.8820935 C198.847252,83.7156137 198.797308,83.549134 198.697421,83.3826542 L198.697421,83.3826542 L197.224075,81.0852336 L199.970991,81.2100935 C200.270654,81.2267414 200.503726,81.1435016 200.670206,80.9603738 C200.836685,80.7772461 200.919925,80.5608224 200.919925,80.3111028 C200.919925,80.0613832 200.836685,79.8449595 200.670206,79.6618318 C200.503726,79.478704 200.270654,79.3954642 199.970991,79.4121121 L199.970991,79.4121121 L197.224075,79.536972 L198.697421,77.2395514 C198.797308,77.0564237 198.847252,76.8899439 198.847252,76.7401121 C198.847252,76.4903925 198.751526,76.2781308 198.560075,76.1033271 C198.368623,75.9285234 198.148037,75.8411215 197.898318,75.8411215 C197.565358,75.8411215 197.315639,76.0076012 197.149159,76.3405607 L197.149159,76.3405607 L195.900561,78.7878131 L194.626991,76.3405607 C194.460511,76.0076012 194.202467,75.8411215 193.85286,75.8411215 C193.60314,75.8411215 193.382555,75.9243614 193.191103,76.0908411 C192.999651,76.2573209 192.903925,76.4654206 192.903925,76.7151402 C192.903925,76.8982679 192.962193,77.0730717 193.078729,77.2395514 L193.078729,77.2395514 L194.552075,79.536972 L191.805159,79.4121121 C191.505495,79.3954642 191.276586,79.478704 191.11843,79.6618318 C190.960274,79.8449595 190.881196,80.0613832 190.881196,80.3111028 C190.881196,80.5608224 190.960274,80.7772461 191.11843,80.9603738 C191.276586,81.1435016 191.505495,81.2267414 191.805159,81.2100935 L191.805159,81.2100935 L194.552075,81.0852336 L193.078729,83.4076262 C192.962193,83.5741059 192.903925,83.7405857 192.903925,83.9070654 C192.903925,84.156785 193.003813,84.3648847 193.203589,84.5313645 C193.403364,84.6978442 193.628112,84.7810841 193.877832,84.7810841 C194.227439,84.7810841 194.477159,84.6229283 194.626991,84.3066168 L194.626991,84.3066168 L195.900561,81.8593645 L197.149159,84.2816449 C197.315639,84.6146044 197.565358,84.7810841 197.898318,84.7810841 Z",
    id: "*****",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(64.000000, 168.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.14622642,50.6458333 C11.0929783,50.6458333 14.2924528,45.8014329 14.2924528,31.8159722 C14.2924528,22.4923318 11.9103774,11.8870077 7.14622642,0 C2.38207547,11.8870077 -1.41220369e-13,22.4923318 -1.41220369e-13,31.8159722 C-1.41220369e-13,45.8014329 3.19947455,50.6458333 7.14622642,50.6458333 Z",
    id: "Oval",
    fill: "#A1A9B5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.14622642,
    y1: 64.28125,
    x2: 7.14622642,
    y2: 19.2627315,
    id: "Line-Copy-2",
    stroke: "#2C3440",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.14520843,
    y1: 37.7544332,
    x2: 1.59843915,
    y2: 32.2106641,
    id: "Line-Copy-2",
    stroke: "#2C3440",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.14520843,
    y1: 25.2011924,
    x2: 4.15158691,
    y2: 22.2091901,
    id: "Line-Copy-4",
    stroke: "#2C3440",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.4762547,
    y1: 30.3956369,
    x2: 6.98734287,
    y2: 25.909153,
    id: "Line-Copy-3",
    stroke: "#2C3440",
    strokeLinecap: "round",
    transform: "translate(9.311750, 28.136574) scale(-1, 1) translate(-9.311750, -28.136574) "
  })), /*#__PURE__*/React.createElement("line", {
    x1: 0.121212121,
    y1: 235.649306,
    x2: 271.878788,
    y2: 235.649306,
    id: "Line-9",
    stroke: "#2C3440",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65.5,
    y1: 255.5,
    x2: 206.5,
    y2: 255.5,
    id: "Line-9",
    stroke: "#2C3440",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 245,
    x2: 248,
    y2: 245,
    id: "Line-9",
    stroke: "#2C3440",
    strokeLinecap: "square",
    strokeDasharray: "4,10,4,10"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10-Copy",
    transform: "translate(210.000000, 208.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.2267755,3.83827778 L5.37991465,3.83827778 C5.37991465,1.71884222 7.23682706,0 9.52910366,0 C11.8197767,0 13.6774909,1.71810038 13.6774909,3.83827778 L13.8306301,3.83827778 C16.7170224,3.83827778 19.0566038,6.00296556 19.0566038,8.67358791 C19.0566038,11.3442103 16.7170224,13.5074144 13.8306301,13.5074144 L5.22597372,13.5074144 C2.33958136,13.5074144 0,11.3442103 0,8.67358791 C0,6.00296556 2.34038314,3.83827778 5.2267755,3.83827778 Z",
    id: "Shape",
    fill: "#A1A9B5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.52830189,
    y1: 4.3287037,
    x2: 9.52830189,
    y2: 22.8197961,
    id: "Shape",
    stroke: "#2C3440",
    fill: "#2C3440",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.52830189,
    y1: 11.3157684,
    x2: 14.0318757,
    y2: 7.3587963,
    id: "Shape",
    stroke: "#2C3440",
    fill: "#2C3440",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.56037291,
    y1: 9.8127875,
    x2: 4.76415094,
    y2: 6.49305556,
    id: "Shape",
    stroke: "#2C3440",
    fill: "#2C3440",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M157.428972,233.756083 C157.388614,233.043433 157.766827,232.568146 158.179634,232.345373 C158.65759,232.090054 159.235288,232.107449 159.721892,232.370625 C160.039569,231.946402 160.442574,231.647313 160.906692,231.498049 C161.433655,231.326901 162.006741,231.360009 162.520442,231.591199 C163.342596,231.96043 163.95604,232.839739 163.701783,233.881779 C164.798372,234.353138 165.084339,235.240864 164.979984,235.905816 C164.844496,236.759313 164.124391,237.378813 163.267068,237.378813 C163.208261,237.379935 159.988256,237.390036 158.034921,237.390036 C156.729046,237.390036 156.067172,236.504554 156.004905,235.682482 C155.948404,234.929991 156.377354,234.058538 157.428972,233.756083 Z",
    id: "Shape-Copy-6",
    fill: "#A1A9B5",
    fillRule: "nonzero",
    transform: "translate(160.500000, 234.390036) scale(-1, 1) translate(-160.500000, -234.390036) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1777789,231.702878 C63.1162723,230.587577 63.6926766,229.84375 64.3218009,229.495109 C65.0502143,229.095532 65.9306368,229.122756 66.6722301,229.534627 C67.1563746,228.870716 67.7705616,228.40264 68.477887,228.169042 C69.280987,227.901194 70.1543801,227.953007 70.9372708,228.314821 C72.1902473,228.89267 73.125147,230.268794 72.7376556,231.899593 C74.4088768,232.637272 74.8446947,234.026569 74.6856563,235.067224 C74.47917,236.40295 73.3817172,237.372472 72.0751421,237.372472 C71.9855183,237.374228 67.0781734,237.390036 64.1012559,237.390036 C62.1110794,237.390036 61.1023718,236.004252 61.0074759,234.717704 C60.9213668,233.540051 61.5750936,232.176222 63.1777789,231.702878 Z",
    id: "Shape-Copy-7",
    fill: "#A1A9B5",
    fillRule: "nonzero",
    transform: "translate(67.858080, 232.695018) scale(-1, 1) translate(-67.858080, -232.695018) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.177779,231.702878 C218.116272,230.587577 218.692677,229.84375 219.321801,229.495109 C220.050214,229.095532 220.930637,229.122756 221.67223,229.534627 C222.156375,228.870716 222.770562,228.40264 223.477887,228.169042 C224.280987,227.901194 225.15438,227.953007 225.937271,228.314821 C227.190247,228.89267 228.125147,230.268794 227.737656,231.899593 C229.408877,232.637272 229.844695,234.026569 229.685656,235.067224 C229.47917,236.40295 228.381717,237.372472 227.075142,237.372472 C226.985518,237.374228 222.078173,237.390036 219.101256,237.390036 C217.111079,237.390036 216.102372,236.004252 216.007476,234.717704 C215.921367,233.540051 216.575094,232.176222 218.177779,231.702878 Z",
    id: "Shape-Copy-7",
    fill: "#A1A9B5",
    fillRule: "nonzero",
    transform: "translate(222.858080, 232.695018) scale(-1, 1) translate(-222.858080, -232.695018) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-5",
    transform: "translate(48.000000, 218.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    stroke: "#2C3440",
    fill: "#A1A9B5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "2.17126179 5.27779438 0.905784198 4.77011207 0.0232252358 2.53775479 2.17126179 2.53775479"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    stroke: "#2C3440",
    fill: "#A1A9B5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "2.17126179 2.53775479 4.31810731 2.53775479 3.43673939 4.77011207 2.17126179 5.27779438 2.17126179 18.9517216"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    stroke: "#2C3440",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "0.0232252358 2.53775479 2.17126179 0.244974777 4.28416274 2.57519061"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#2C3440",
    points: "3.24438679 19.4791667 3.24438679 19.4791667 1.0635967 19.4791667 1.0635967 19.4791667 1.0635967 15.4412921 1.0635967 15.4412921 3.24438679 15.4412921 3.24438679 15.4412921"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-5",
    transform: "translate(207.000000, 218.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    stroke: "#2C3440",
    fill: "#A1A9B5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "2.17126179 5.27779438 0.905784198 4.77011207 0.0232252358 2.53775479 2.17126179 2.53775479"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    stroke: "#2C3440",
    fill: "#A1A9B5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "2.17126179 2.53775479 4.31810731 2.53775479 3.43673939 4.77011207 2.17126179 5.27779438 2.17126179 18.9517216"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    stroke: "#2C3440",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "0.0232252358 2.53775479 2.17126179 0.244974777 4.28416274 2.57519061"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#2C3440",
    points: "3.24438679 19.4791667 3.24438679 19.4791667 1.0635967 19.4791667 1.0635967 19.4791667 1.0635967 15.4412921 1.0635967 15.4412921 3.24438679 15.4412921 3.24438679 15.4412921"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-5",
    transform: "translate(155.000000, 218.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    stroke: "#2C3440",
    fill: "#A1A9B5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "2.17126179 5.27779438 0.905784198 4.77011207 0.0232252358 2.53775479 2.17126179 2.53775479"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    stroke: "#2C3440",
    fill: "#A1A9B5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "2.17126179 2.53775479 4.31810731 2.53775479 3.43673939 4.77011207 2.17126179 5.27779438 2.17126179 18.9517216"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    stroke: "#2C3440",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "0.0232252358 2.53775479 2.17126179 0.244974777 4.28416274 2.57519061"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#2C3440",
    points: "3.24438679 19.4791667 3.24438679 19.4791667 1.0635967 19.4791667 1.0635967 19.4791667 1.0635967 15.4412921 1.0635967 15.4412921 3.24438679 15.4412921 3.24438679 15.4412921"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.8173242,70.7858796 C19.8173242,63.6138485 25.6345506,57.7997685 32.8104631,57.7997685 C35.5071244,57.7997685 38.0119111,58.6208373 40.088209,60.0264888 C44.3511793,49.4581041 54.7087399,42 66.8091767,42 C75.8066414,42 83.8404884,46.1235062 89.1220858,52.582854 C90.8980352,52.0346183 92.7867571,51.7395833 94.7444254,51.7395833 C105.269097,51.7395833 113.801029,60.2669006 113.801029,70.7858796 L113.801029,70.7858796 Z",
    id: "Combined-Shape",
    fill: "#646C78"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 91.0008576,
    y1: 63.9884259,
    x2: 71.0008576,
    y2: 63.9884259,
    id: "Shape",
    stroke: "#646C78",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.422813,
    y1: 42.3449074,
    x2: 11.422813,
    y2: 42.3449074,
    id: "Shape",
    stroke: "#646C78",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.7538593,
    y1: 42.3449074,
    x2: 17.7538593,
    y2: 42.3449074,
    id: "Shape",
    stroke: "#646C78",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.6972556,
    y1: 42.3449074,
    x2: 4.69725557,
    y2: 42.3449074,
    id: "Shape",
    stroke: "#646C78",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 110.43825,
    y1: 43.6435185,
    x2: 108.43825,
    y2: 43.6435185,
    id: "Shape",
    stroke: "#646C78",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 177,
    y1: 59.3009259,
    x2: 175,
    y2: 59.3009259,
    id: "Shape",
    stroke: "#646C78",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 169.331046,
    y1: 59.3009259,
    x2: 167.331046,
    y2: 59.3009259,
    id: "Shape",
    stroke: "#646C78",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160.766724,
    y1: 293.988426,
    x2: 140.766724,
    y2: 293.988426,
    id: "Shape",
    stroke: "#646C78",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 209.746141,
    y1: 288.918981,
    x2: 189.746141,
    y2: 288.918981,
    id: "Shape",
    stroke: "#646C78",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 133.780446,
    y1: 328.618056,
    x2: 131.780446,
    y2: 328.618056,
    id: "Shape",
    stroke: "#646C78",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140.111492,
    y1: 328.618056,
    x2: 138.111492,
    y2: 328.618056,
    id: "Shape",
    stroke: "#646C78",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 146.054889,
    y1: 328.618056,
    x2: 126.054889,
    y2: 328.618056,
    id: "Shape",
    stroke: "#646C78",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 69.084048,
    y1: 272.344907,
    x2: 67.084048,
    y2: 272.344907,
    id: "Shape",
    stroke: "#646C78",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 75.4150943,
    y1: 272.344907,
    x2: 73.4150943,
    y2: 272.344907,
    id: "Shape",
    stroke: "#646C78",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.3584906,
    y1: 272.344907,
    x2: 60.3584906,
    y2: 272.344907,
    id: "Shape",
    stroke: "#646C78",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 112.725557,
    y1: 268.016204,
    x2: 110.725557,
    y2: 268.016204,
    id: "Shape",
    stroke: "#646C78",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 121.056604,
    y1: 268.016204,
    x2: 119.056604,
    y2: 268.016204,
    id: "Shape",
    stroke: "#646C78",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56.7255575,
    y1: 298.31713,
    x2: 54.7255575,
    y2: 298.31713,
    id: "Shape",
    stroke: "#646C78",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49.0566038,
    y1: 298.31713,
    x2: 47.0566038,
    y2: 298.31713,
    id: "Shape",
    stroke: "#646C78",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 298.31713,
    x2: 36,
    y2: 298.31713,
    id: "Shape",
    stroke: "#646C78",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195.346484,
    y1: 268.016204,
    x2: 193.346484,
    y2: 268.016204,
    id: "Shape",
    stroke: "#646C78",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.67753,
    y1: 268.016204,
    x2: 187.67753,
    y2: 268.016204,
    id: "Shape",
    stroke: "#646C78",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 196.620926,
    y1: 268.016204,
    x2: 176.620926,
    y2: 268.016204,
    id: "Shape",
    stroke: "#646C78",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 247.303602,
    y1: 148.986111,
    x2: 245.303602,
    y2: 148.986111,
    id: "Shape",
    stroke: "#646C78",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 251.634648,
    y1: 148.986111,
    x2: 249.634648,
    y2: 148.986111,
    id: "Shape",
    stroke: "#646C78",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 51,
    y1: 106,
    x2: 49,
    y2: 106,
    id: "Shape",
    stroke: "#646C78",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55.3310463,
    y1: 106,
    x2: 53.3310463,
    y2: 106,
    id: "Shape",
    stroke: "#646C78",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 135,
    y1: 9,
    x2: 133,
    y2: 9,
    id: "Shape",
    stroke: "#646C78",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 143.331046,
    y1: 9,
    x2: 141.331046,
    y2: 9,
    id: "Shape",
    stroke: "#646C78",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 206.274443,
    y1: 59.3009259,
    x2: 186.274443,
    y2: 59.3009259,
    id: "Shape",
    stroke: "#646C78",
    strokeWidth: 2,
    strokeLinecap: "round"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordResetImg);
export default __webpack_public_path__ + "static/media/password-reset-img.ec2ca7f3613a3b43a35c12b461c0d00b.svg";
export { ForwardRef as ReactComponent };